import { useEffect } from "react";

import { useAppDispatch } from "app/redux-store-interactions";
import { renderActions } from "features/render/renderSlice";

/** Clears octree debug render state when the octree debug UI unmounts. */
export function useResetOctreeDebugOnUnmount() {
    const dispatch = useAppDispatch();

    useEffect(() => () => void dispatch(renderActions.resetOctreeDebug()), [dispatch]);
}
